export class RelatorioAnaliticoModel {
  atributo?: string;
  informacao?: string;
  finalidade?: string;
  origem?: string;
  disclaimer?: boolean;
  divisao?: string; ///// Campo utilizado para subdividir os blocos existentes
  cnpj?: string;
  dtSearch?: Date;
  empresa?: string;
  numSearches?: number;
}

export class RelatorioAnaliticoScrModel {
  atributo?: string;
  financialInstitution?: string;
  contract?: string;
  modality?: string;
  disclaimer?: boolean;
  referenceDate?: string;
  informacao?: string;
  finalidade?: string;
  origem?: string;
}